import API from "./axios";

export class CatalogueService {
    constructor() {

    }
    catalogues(brandid:any): Promise<any> {
        return API.post(`api/index.php`, {"action":"getCatalogs","src":"dashboard","brandid":brandid,"retrievalmode":"mysql"});
    }

    createCatalog( data: any): Promise<any> {
      
        return API.post(`api/index.php`, { 'action': 'CatalogDataAction', 'src': 'dashboard', retrievalmode: 'mysql',  'data': [data] });
    }

}